import React from 'react';
import {useStyles} from './style';
import CssBaseline from '@mui/material/CssBaseline';
import {AppBar, Toolbar} from '@mui/material';

export default function Footer() {
    const classes = useStyles();
    return (
    <React.Fragment>
        <CssBaseline />
        <AppBar position="fixed" className={classes.appBar}>
            <Toolbar variant="dense" className={classes.toolbar} >
                <img className={classes.appIcon} src="assets/WhiteIcon.svg"  alt="fireSpot"/>
                <p className={classes.title}>
                    TRIBUNAL SUPREMO ELECTORAL
                </p>
                <p className={classes.lastTitle}>GUATEMALA, C.A</p>
            </Toolbar>
        </AppBar>
    </React.Fragment>
    );
}
